export enum Provinces {
  AB = 'CA-AB',
  BC = 'CA-BC',
  PE = 'CA-PE',
  MB = 'CA-MB',
  NB = 'CA-NB',
  NS = 'CA-NS',
  ON = 'CA-ON',
  QC = 'CA-QC',
  SK = 'CA-SK',
  NL = 'CA-NL',
  NU = 'CA-NU',
  NT = 'CA-NT',
  YT = 'CA-YT',
}

export default Provinces;
